// @flow
// API Contact static class

export default class Contact {
  // Send Contact form
  static Form(api: Object, data: Object) {
    return api.POST("/contact", data);
  }
}
